import { createContext, useContext, useMemo } from 'react';

const CurrentPressroomContext = createContext<{ pressroomId: string; sourceId: string }>({
  pressroomId: '',
  sourceId: '',
});

export const CurrentPressroomContextProvider = ({
  sourceId,
  pressroomId,
  children,
}: {
  sourceId: string | undefined;
  pressroomId: string | undefined;
  children: React.ReactNode;
}) => {
  return (
    <CurrentPressroomContext.Provider
      value={useMemo(() => {
        return {
          sourceId: sourceId || '',
          pressroomId: pressroomId || '',
        };
      }, [sourceId, pressroomId])}
    >
      {children}
    </CurrentPressroomContext.Provider>
  );
};

export const useCurrentPressroom = () => useContext(CurrentPressroomContext);
